import axios from 'axios';
import auth from './auth';
import file from './file';
import news from './news';
import products from './products';
import solution from './solution';
import messages from './messages';
import { navigateTo } from '@/utils/router';

// 创建 axios 实例
const api = axios.create({
    baseURL: '/api/tianyu/',
    timeout: 30000
})
  
  // 请求拦截器
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    if (config.isAuth && token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
})
  
  // 响应拦截器
api.interceptors.response.use(
    response => response.data,
    error => {
      if (error.response?.status === 400 || error.response?.status === 401) {
        navigateTo({name: 'login'})
      }
      return Promise.reject(error.response?.data || error.message)
    }
)
  
  // 导出所有模块API
export default {
    auth,
    file,
    news,
    products,
    solution,
    messages,
    raw: api
}